import React from "react";
import { Paper, Box, Typography, IconButton } from "@mui/material";
import { FileText as FileTextIcon, Pencil as PencilIcon, Trash as TrashIcon, ChevronRight as ChevronRightIcon } from "lucide-react";

const SectionItem = ({ section, onSelectSection, onEdit, onDelete }) => {
  const handleSelect = (e) => {
    onSelectSection(section._id);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    if (onEdit) onEdit(section);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (onDelete) onDelete(section);
  };

  const handleView = (e) => {
    e.stopPropagation();
    onSelectSection(section._id);
  };

  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        mb: 1,
        borderRadius: 2,
        cursor: 'pointer',
        transition: 'all 0.2s',
        borderLeft: 'none',
        background: 'white',
        '&:hover': {
          bgcolor: '#f5f5f5'
        }
      }}
      onClick={handleSelect}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <FileTextIcon size={18} color="#1976d2" style={{ marginRight: 8 }} />
            <Typography variant="subtitle1" fontWeight="medium">
              #{section.order} {section.title}
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {section.description}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex' }}>
          <IconButton size="small" color="primary" onClick={handleEdit} title="Edit Section">
            <PencilIcon size={16} />
          </IconButton>
          <IconButton size="small" color="error" onClick={handleDelete} title="Delete Section">
            <TrashIcon size={16} />
          </IconButton>
          <IconButton size="small" color="primary" onClick={handleView} title="View Section">
            <ChevronRightIcon size={16} />
          </IconButton>
        </Box>
      </Box>
    </Paper>
  );
};

export default SectionItem;
